<template>
	<v-card elevation="0" class="rounded-lg pa-2" color="#F5F6F9">
		<div class="text-center pt-2 d-flex justify-center">
			<v-img v-if="loan.imageUrl" :src="loan.imageUrl" width="135px" />
			<v-icon v-else size="100" color="grey">mdi-account-cash</v-icon>
		</div>
		<v-sheet class="pa-1 rounded-md" color="white" style="min-height: 90px;">
			<div class="text-right pa-2" style="overflow: hidden;height: 60px;">{{ loan.planTitle }}</div>
			<div class="d-flex flex-wrap">
				<v-chip class="mx-2 mb-1" color="#e7fee8" x-small v-if="!loan.profitPercent">بدون سود</v-chip>
				<v-chip class="mx-2 mb-1" color="#e7fee8" x-small v-else>سود: {{ loan.profitPercent }}</v-chip>
				<v-chip class="mx-2 mb-1" color="#e7fee8" x-small v-if="!loan.delayPercent">بدون جریمه</v-chip>
				<v-chip class="mx-2 mb-1" color="#e7fee8" x-small v-if="!!loan.earlyPercent">سود زودکرد</v-chip>
				<v-chip class="mx-2 mb-1" color="#e7fee8" x-small v-if="!loan.allowedInstallments">بازپرداخت دلخواه</v-chip>
				<v-chip class="mx-2 mb-1" color="#e7fee8" x-small v-if="maxMonth">حداکثر بازپرداخت: {{ maxMonth }} <small class="mr-1">ماهه</small></v-chip>
				<v-chip class="mx-2 mb-1" color="#e7fee8" x-small v-if="maxAmount">سقف تسهیلات: {{ String(maxAmount).toPriceFormat() }} <small class="mr-1">تومان</small></v-chip>
				<v-chip class="mx-2 mb-1" color="#ffccdd" x-small v-if="loan.disable">غیر فعال</v-chip>
			</div>
		</v-sheet>
	</v-card>
</template>

<script>
	import { get } from 'vuex-pathify'

	export default {
		name: 'PlanGridItem',
		props: {
			loan: {
				type: Object,
			},
		},
		data: () => ({}),
		computed: {
			maxAmount() {
				if (!this.loan.allowedInstallments || !this.loan.allowedInstallments.includes('['))
					return this.loan.maxAmount || 0

				let arr = JSON.parse(this.loan.allowedInstallments)
				let max = Math.max(...arr.map(obj => obj.max))
				return max || this.loan.maxAmount || 0
			},
			maxMonth() {
				if (!this.loan.allowedInstallments)
					return 0

				if (!this.loan.allowedInstallments.includes('['))
					return this.loan.allowedInstallments

				let arr = JSON.parse(this.loan.allowedInstallments)
				let max = Math.max(...arr.map(obj => obj.value))
				return max || 0
			}
		},
	}
</script>
